import styled from 'styled-components';
import { colors } from 'styles/colors';

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  margin-top: -20px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
  gap: 16px;
  padding-top: 112px;

  @media (min-width: 769px) {
    padding-top: 66px;
  }
`;

export const HistoryGraphLoading = styled.div`
  margin-top: -4px;

  @media (max-width: 768px) {
    width: 100%;

    .skeleton-container-span {
      width: 100%;
    }

    .skeleton-span {
      width: 100%;
    }
  }
`;

export const HistoryGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: flex-start;
  padding: 20px;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TitleGraph = styled.h3<{ comingSoon?: boolean }>`
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.text['main-900']};

  ${({ comingSoon }) => (comingSoon ? `
    opacity: 0.6;
  ` : '')}
`;

export const BetaContent = styled.div`
  position: absolute;
  top: 0;
  background: #363BC4;
  color: white;
  font-weight: 700;
  font-size: 10px;
  height: 35px;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 5px 3px;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%);
  right: 40px;
`;

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  & > .tooltip-bignumber {
    opacity: 1 !important;
    padding: 4px 8px !important;
  }
`;

export const HistoryTooltip = styled.div`
  width: 166px;
  text-align: center;

  & > span {
    font-size: 14px;
    color: ${colors.text['white-0']};
    font-weight: 400;
    line-height: 130%;
  }
`;
